import { ListRender } from "../../shared/components/base/list/ListRender";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ConfirmModalRender } from "../../shared/components/implementations/modal/ConfirmModalRender";
import { CompraDetailModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/CompraDetailModalRender";
import { CompraListItemRender } from "../../shared/components/modulos/pesaje/ganaderia/list/CompraListItemRender";
import { CompraModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/CompraModalRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import {
  fx_createCompraAnimalesRequest,
  fx_createCompraAnimalesRequestEmpty,
} from "../../shared/modulos/pesaje/ganaderia/request/CompraAnimalesRequest";
import { CompraAnimalesResponse } from "../../shared/modulos/pesaje/ganaderia/response/CompraAnimalesResponse";
import { CompraAnimalesDeleteGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/CompraAnimalesDeleteGrpcService";
import { fx_createCompraAnimalesGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/CompraAnimalesGrpcService";

/** Página de compras (pesaje · ganadería): sección + lista de compras de la finca
 *  activa. (Fase 1: solo lectura; alta/ver/editar/eliminar en fases siguientes.) */
export class ComprasPage implements IPage {
  /** Lista de compras (sección + filas). Se crea en `render` (ver nota). */
  private _list: ListRender<CompraAnimalesResponse> | null = null;

  /** Monta la sección/lista en el contenedor de la página.
   *  La lista se construye aquí (no en el constructor) porque `AppRender` llama
   *  `dispose()` de la página antes de `render()`; hacerlo en el constructor
   *  dejaría la lista disposed antes de cargar. */
  render(
    pageContent: HTMLDivElement,
    _secondSidebarWrapper: HTMLDivElement,
  ): void {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    this._list = new ListRender<CompraAnimalesResponse>({
      label: "PESAJE · GANADERÍA",
      title: "Compras",
      subtitle: `${finca.nombreFinca} · Registro de compras de animales`,
      addLabel: "Nueva compra",
      onAdd: () => {
        const request = fx_createCompraAnimalesRequestEmpty(finca.id);
        // GDP esperado por defecto: crecimiento diario óptimo de la finca.
        request.gdpEsperadoGr = finca.ganaderiaCrecimientoDiarioGr;
        new CompraModalRender(request).init();
      },
      listService: fx_createCompraAnimalesGrpcService(finca.id),
      createItem: (compra) =>
        new CompraListItemRender(compra, {
          onView: (c) => new CompraDetailModalRender(c).init(),
          onEdit: (c) => {
            const request = fx_createCompraAnimalesRequest(c);
            request.gdpEsperadoGr = finca.ganaderiaCrecimientoDiarioGr;
            new CompraModalRender(request).init();
          },
          onDelete: (c) =>
            new ConfirmModalRender({
              title: "Eliminar compra",
              message: `¿Está seguro que desea eliminar la compra <strong>${c.codigo ?? ""}</strong> de <strong>${finca.nombreFinca}</strong>? Esta acción no se puede deshacer.`,
              onConfirm: async () => {
                await new CompraAnimalesDeleteGrpcService().deleteAsync(c);
                serviceProvider.getLayoutService().reload();
              },
            }).init(),
        }),
      emptyMessage: "Sin compras registradas",
    });

    pageContent.innerHTML = this._list.render();
    this._list.connect();
  }

  /** Dispone la lista. */
  dispose(): void {
    this._list?.dispose();
    this._list = null;
  }
}
